/**
 * Background Rotation Utility
 * Manages random background selection and session persistence
 */

// Available background images for dashboard pages
const BACKGROUND_IMAGES = [
  '/assets/images/tmps55og_72-1766900590404.jpg', // Library study background
  '/assets/images/tmpyotwlz8z-1766902681086.jpg'   // Outdoor planner background
];

// Session storage key for background persistence
const STORAGE_KEY = 'dashboard_background_image';

/**
 * Get a random background image from the available pool
 * @returns {string} Path to background image
 */
const getRandomBackground = () => {
  const randomIndex = Math.floor(Math.random() * BACKGROUND_IMAGES?.length);
  return BACKGROUND_IMAGES?.[randomIndex];
};

/**
 * Get background image for current session
 * Returns stored background if exists, otherwise selects and stores a new random one
 * @returns {string} Path to background image
 */
export const getSessionBackground = () => {
  // Check if background is already stored for this session
  let storedBackground = sessionStorage.getItem(STORAGE_KEY);
  
  if (!storedBackground) {
    // No stored background - select random and store it
    storedBackground = getRandomBackground();
    sessionStorage.setItem(STORAGE_KEY, storedBackground);
  }
  
  return storedBackground;
};

/**
 * Clear stored background (useful for testing or manual rotation)
 */
export const clearSessionBackground = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

/**
 * Force new random background (clears stored and returns new random)
 * @returns {string} Path to new background image
 */
export const rotateBackground = () => {
  clearSessionBackground();
  return getSessionBackground();
};